class BackToTop {
    constructor(context, settings, $, debounce, Ps) {
        // Environment variables
        this.context = context;
        this.settings = settings;
        this.$ = $;
        this.Ps = Ps;

        // General variables
        this.$window = this.$(window);
        this.$body = this.$('body', this.context);
        this.$html = this.$('html', this.context);

        // Specific variables
        this.$wrapper = this.$('.js-back-to-top-wrapper', this.context).once();
        this.$button = this.$('.js-back-to-top-button', this.context).once();
        this.$footer = this.$('.js-footer', this.context).once();
        this.$footerPlaceholder = this.$('.js-footer-placeholder', this.context);
        this.$mobileBreakpoint = 767;

        // Events
        this.$button.on('click', $.proxy(this.scrollToTop, this));
        this.$window.on('scroll', $.proxy(this.toggleTopButton, this));

        // Prevent button from clashing with the footer
        this.$window.on('load', () => {
            if ('IntersectionObserver' in window &&
                'IntersectionObserverEntry' in window) {
                this.observeFooter();
            } else {
                // Fallback if IntersectionObserver doesn't work
                this.$wrapper.addClass('is-visible');
            }
        });
    }

    scrollToTop() {
        this.$('body, html').animate({scrollTop: 0}, "slow");
    }

    toggleTopButton() {
        // If it's mobile width
        if (this.$window.width() < this.$mobileBreakpoint) {
            if (this.$window.height() + this.$window.scrollTop() > this.$window.height()) {
                this.$wrapper.addClass('is-visible');
            } else {
                this.$wrapper.removeClass('is-visible');
            }
        }
    }

    observeFooter() {
        if (this.$footerPlaceholder.length) {
            const footerObserver = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    this.$wrapper.addClass('is-hidden');
                } else {
                    this.$wrapper.removeClass('is-hidden');
                }
            });

            footerObserver.observe(this.$footerPlaceholder[0]);
        }
    }
}

export default BackToTop;

